import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const p=t("burkina_faso",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5L24 20.5L0 20.5"
                fill="#EE2222" />
            <path
                d="M0 12.5L24 12.5L24 20.5H0"
                fill="#009944" />
            <path
                d="M10.4028 14.633L12.0028 9.83301L13.6028 14.633L9.49609 11.6997H14.5628"
                fill="#FFDD00" />
        </svg>
    `),r=t("burkina_faso_rounded",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_118298)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M-6 0.5L30 0.5L30 24.5L-6 24.5"
                    fill="#EE2222" />
                <path
                    d="M-6 12.5L30 12.5V24.5L-6 24.5"
                    fill="#009944" />
                <path
                    d="M9.60219 15.7L12.0022 8.5L14.4022 15.7L8.24219 11.3L15.8422 11.3"
                    fill="#FFDD00" />
            </g>
            <defs>
                <clipPath id="clip0_19477_118298">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{p as BurkinaFaso,r as BurkinaFasoRounded};
